import { Log, UserManager } from 'oidc-client';
import config from '../config';
import { getApi } from '../apiBase';
import { ids_clientId } from '../apiURL';

export class IDSAuthService {
  userManager;
  constructor() {
    // Calling API to get ClientID for Tenant
   // if (localStorage.getItem("IDSclientID") != "") {
      //  getApi(ids_clientId).then(resp => {
      //    localStorage.setItem("IDSclientID", resp.data.data);
      //    console.log(resp.data.user) 
      //  })
  //  } 

    const { sts_authority, client_id, clientScope } = config.ids
    let originRoot = `${window.location.origin}`;
    const settings = {
      client_id: localStorage.getItem("IDSclientID"),
      authority: localStorage.getItem("IDSstsAthourity"),
      silent_redirect_uri: `${originRoot}`,
      redirect_uri: `${originRoot}/signin-callback.html?returnUrl=${originRoot}/signin-callback.html`,
      post_logout_redirect_uri: `${originRoot}/#/signout?returnUrl=${originRoot}/#/signout`,
      response_type: "id_token",
      scope: localStorage.getItem("IDSclientScope"),
      filterProtocolClaims: true,
      loadUserInfo: true,
      automaticSilentRenew: true,
    };
    this.userManager = new UserManager(settings);
    Log.logger = console;
    Log.level = Log.INFO;
  }

  getUser = () => {
    return this.userManager.getUser();
  }

  login = () => {
    // return this.userManager.signinRedirect({ state: { bar: 15 } });
    return this.userManager.signinRedirect();

  }

  renewToken = () => {
    return this.userManager.signinSilent();
  }

  logout = () => {
    return this.userManager.signoutRedirect();
  }
}
